import { DrawerLevelPositionTypes, DrawerVariantPositionTypes, } from '@kubit/web-ui-components/drawer/types';
import { FONT_WEIGHT, TEXT_ALIGN } from '../../foundations/typography';
import { TextVariantType } from '../text/variants';
export const commonStyles = (FOUNDATIONS, DEVICE_TOKENS, SHADOWS) => ({
    container: {
        ...DEVICE_TOKENS.container,
    },
    iconContainer: {
        padding_top: `calc(${FOUNDATIONS.spacing_250} + ${FOUNDATIONS.size_100})`, //padding + decorative line height
        padding_right: FOUNDATIONS.spacing_250,
        padding_bottom: FOUNDATIONS.spacing_250,
        padding_left: FOUNDATIONS.spacing_250,
        ...DEVICE_TOKENS.iconContainer,
    },
    icon: {
        width: FOUNDATIONS.size_250,
        height: FOUNDATIONS.size_250,
        color: FOUNDATIONS.color_neutral_icon_50,
        ...DEVICE_TOKENS.icon,
    },
    titleContentFooterContainer: {
        ...DEVICE_TOKENS.titleContentFooterContainer,
    },
    titleSubtitleWrapper: {
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_150,
        padding_bottom: FOUNDATIONS.spacing_250,
        box_shadow: SHADOWS.shadow_40,
        ...DEVICE_TOKENS.titleSubtitleWrapper,
    },
    titleContainer: {
        ...DEVICE_TOKENS.titleContainer,
    },
    title: {
        font_variant: TextVariantType.FONT_HEADING_300,
        font_weight: FONT_WEIGHT.font_bold,
        color: FOUNDATIONS.color_neutral_font_50,
        ...DEVICE_TOKENS.title,
    },
    subtitleContainer: {
        ...DEVICE_TOKENS.subtitleContainer,
    },
    subtitle: {
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        color: FOUNDATIONS.color_neutral_font_100,
        ...DEVICE_TOKENS.subtitle,
    },
    content: {
        ...DEVICE_TOKENS.content,
    },
    footer: {
        ...DEVICE_TOKENS.footer,
    },
    [DrawerLevelPositionTypes.FIRST_LEVEL]: {
        containerPosition: DrawerVariantPositionTypes.DRAWER_RIGHT,
    },
    [DrawerLevelPositionTypes.SECOND_LEVEL]: {
        containerPosition: DrawerVariantPositionTypes.DRAWER_RIGHT,
    },
});
export const drawerVariantPositionCommonStyles = (FOUNDATIONS) => ({
    display: 'flex',
    flex_direction: 'column',
    background_color: FOUNDATIONS.color_comp_containers_bg,
    max_height: '100vh',
    before: {
        content: '',
        position: 'absolute',
        width: '100%',
        height: FOUNDATIONS.size_100,
        background_color: FOUNDATIONS.color_comp_containers_drawer_topline_bg,
    },
});
export const desktopCommonStyles = (FOUNDATIONS, SHADOWS) => ({
    ...commonStyles(FOUNDATIONS, {
        container: {
            [DrawerVariantPositionTypes.DRAWER_RIGHT]: {
                ...drawerVariantPositionCommonStyles(FOUNDATIONS),
            },
            [DrawerVariantPositionTypes.DRAWER_LEFT]: {
                ...drawerVariantPositionCommonStyles(FOUNDATIONS),
            },
            [DrawerVariantPositionTypes.DRAWER_BOTTOM]: {
                ...drawerVariantPositionCommonStyles(FOUNDATIONS),
            },
        },
        titleSubtitleWrapper: {
            padding_left: FOUNDATIONS.spacing_300,
            padding_right: FOUNDATIONS.spacing_300,
        },
        content: {
            padding_left: FOUNDATIONS.spacing_300,
            padding_right: FOUNDATIONS.spacing_300,
            padding_bottom: FOUNDATIONS.spacing_300,
        },
        footer: {
            padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_300}`,
        },
    }, SHADOWS),
});
export const tabletCommonStyles = (FOUNDATIONS, SHADOWS) => ({
    ...commonStyles(FOUNDATIONS, {
        container: {
            [DrawerVariantPositionTypes.DRAWER_RIGHT]: {
                ...drawerVariantPositionCommonStyles(FOUNDATIONS),
                min_height: 'var(--100svh, 100vh)',
                min_width: '100vw',
            },
            [DrawerVariantPositionTypes.DRAWER_LEFT]: {
                ...drawerVariantPositionCommonStyles(FOUNDATIONS),
                min_height: 'var(--100svh, 100vh)',
                min_width: '100vw',
            },
            [DrawerVariantPositionTypes.DRAWER_BOTTOM]: {
                ...drawerVariantPositionCommonStyles(FOUNDATIONS),
                min_height: 'var(--100svh, 100vh)',
                min_width: '100vw',
            },
        },
        iconContainer: {
            padding: FOUNDATIONS.spacing_250,
        },
        titleSubtitleWrapper: {
            padding_left: FOUNDATIONS.spacing_300,
            padding_right: FOUNDATIONS.spacing_300,
        },
        titleContainer: {
            text_align: TEXT_ALIGN.left,
        },
        subtitleContainer: {
            text_align: TEXT_ALIGN.left,
        },
        content: {
            padding_left: FOUNDATIONS.spacing_300,
            padding_right: FOUNDATIONS.spacing_300,
            padding_bottom: FOUNDATIONS.spacing_300,
        },
        footer: {
            padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_300} `,
        },
    }, SHADOWS),
});
export const mobileCommonStyles = (FOUNDATIONS, SHADOWS) => ({
    ...commonStyles(FOUNDATIONS, {
        container: {
            [DrawerVariantPositionTypes.DRAWER_RIGHT]: {
                ...drawerVariantPositionCommonStyles(FOUNDATIONS),
                min_width: '100vw',
            },
            [DrawerVariantPositionTypes.DRAWER_LEFT]: {
                ...drawerVariantPositionCommonStyles(FOUNDATIONS),
                min_width: '100vw',
            },
            [DrawerVariantPositionTypes.DRAWER_BOTTOM]: {
                ...drawerVariantPositionCommonStyles(FOUNDATIONS),
                min_width: '100vw',
            },
        },
        iconContainer: {
            padding_top: FOUNDATIONS.spacing_250,
            padding_left: FOUNDATIONS.spacing_250,
            padding_right: FOUNDATIONS.spacing_250,
            padding_bottom: FOUNDATIONS.spacing_250,
        },
        titleContentFooterContainer: {
            paddingTopIsBlocking: FOUNDATIONS.spacing_600,
        },
        titleSubtitleWrapper: {
            padding_left: FOUNDATIONS.spacing_250,
            padding_right: FOUNDATIONS.spacing_250,
        },
        titleContainer: {
            text_align: TEXT_ALIGN.left,
        },
        subtitleContainer: {
            text_align: TEXT_ALIGN.left,
        },
        content: {
            padding_left: FOUNDATIONS.spacing_250,
            padding_right: FOUNDATIONS.spacing_250,
            padding_bottom: FOUNDATIONS.spacing_300,
        },
        footer: {
            padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_250} `,
        },
    }, SHADOWS),
});
//# sourceMappingURL=commonStyles.js.map